import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex mb-20 mt-20" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("返回 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新建收款二维码")
const _hoisted_4 = {
  class: "d-flex align-items-center",
  style: {"margin-top":"-5px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mr-10" }, "显示已关闭和已过期:", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看 ")

import {onBeforeMount, onMounted, onUpdated, reactive, watch} from "vue";
import QrDialog from "@/views/ViewsComponents/myOrderCollection/QrDialog.vue";
import Api from "@/http/modules";
import tbMix from "@/global_mixin/tableMixin";
import dayjs from "dayjs";
import {onActivated} from "@vue/runtime-core";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 订单收款_无订单收款列表
  'POST/order/receipt/without_order_records': recordsApi,
} = Api
const qrDialogInfo = reactive({
  isShow: false,
  type: 'order',
  orders: [],
  order: {},
  qrInfo: {}
})
const searchObj = reactive({
  filterExpiredAndClosed: false
})
const generateCode = () => {
  qrDialogInfo.type = "withoutOrder"
  qrDialogInfo.isShow = false
  setTimeout(() => {
    qrDialogInfo.isShow = true
  }, 50)
}

onActivated(()=>{
  refreshPageData()
})
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(recordsApi)
const refreshPageData = () => {
  page.value = 1
  fetchData({filterExpiredAndClosed: searchObj.filterExpiredAndClosed})
}
watch(()=>searchObj.filterExpiredAndClosed,(n,o)=>{
  refreshPageData()
})
const showHistoryCode = (row: any) => {
  qrDialogInfo.qrInfo = {
    payType: row.payType,
    paymentAmount:  row.paymentAmount,
    expirationTime: dayjs(row.createTime).add(2, 'hour').format('YYYY-MM-DD HH:mm:ss'),
    code: row.code,
    showQr:true
  }
  qrDialogInfo.type = 'showQr'
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        icon: "back",
        type: "info",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ path: '/my-order-collection' })))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        class: "ml-20 mr-20",
        onClick: generateCode
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_checkbox, {
          modelValue: _unref(searchObj).filterExpiredAndClosed,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).filterExpiredAndClosed) = $event)),
          label: "",
          size: "large"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "tb",
        border: "",
        data: _unref(MI_tableData),
        class: "mt-10",
        "max-height": _unref(MI_height) - 60 + 'px'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "金额",
            prop: "paymentAmount",
            "min-width": "100"
          }),
          _createVNode(_component_el_table_column, {
            label: "创建时间",
            prop: "createTime",
            "min-width": "160"
          }),
          _createVNode(_component_el_table_column, {
            label: "创建人",
            prop: "userName",
            "min-width": "160"
          }),
          _createVNode(_component_el_table_column, {
            label: "支付状态",
            prop: "tradeStateDesc",
            "min-width": "100"
          }),
          _createVNode(_component_el_table_column, {
            label: "收款方式",
            prop: "payType",
            "min-width": "100"
          }),
          _createVNode(_component_el_table_column, {
            label: "备注",
            prop: "note",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            "min-width": "100"
          }, {
            default: _withCtx(({row}) => [
              _createVNode(_component_el_space, null, {
                default: _withCtx(() => [
                  (row.tradeState?.toUpperCase() === 'NOTPAY')
                    ? (_openBlock(), _createBlock(_component_el_link, {
                        key: 0,
                        type: "primary",
                        onClick: ($event: any) => (showHistoryCode(row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "max-height"])), [
        [_directive_loading, _unref(MI_identify)]
      ]),
      _createVNode(_component_el_pagination, {
        background: "",
        small: "",
        class: "mt-10",
        disabled: _unref(MI_identify),
        total: _unref(MI_total),
        currentPage: _unref(page),
        "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
        "page-size": _unref(size),
        "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
        "page-sizes": [30, 50, 100, 500],
        layout: "sizes, prev, pager, next, total, jumper",
        onCurrentChange: _unref(MI_pageChange),
        onSizeChange: _unref(MI_sizeChange)
      }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
    ]),
    _createVNode(QrDialog, {
      "is-show": _unref(qrDialogInfo).isShow,
      type: _unref(qrDialogInfo).type,
      order: _unref(qrDialogInfo).order,
      "qr-info": _unref(qrDialogInfo).qrInfo,
      orders: _unref(qrDialogInfo).orders,
      onRefresh: refreshPageData
    }, null, 8, ["is-show", "type", "order", "qr-info", "orders"])
  ]))
}
}

})